import gpaCalculatorReducer from './reducers';
import * as gpaCalculatorActions from './actions';

export default gpaCalculatorReducer;

export { gpaCalculatorReducer, gpaCalculatorActions };
